export class Paths {
  static WelcomePage = "/"

  static RulesPage = "/rules"

  static GuidesPage = "/guides"
  static GuidesBeginnersPage = "/guides/beginners"
  static GuidesMapAndMarkersPage = "/guides/mapAndMarkers"
  static GuideTerjeMedicinePage = "/guides/terjemedicine"
  static GuidesTradersPage = "/guides/traders"
  static GuidesVehiclesPage = "/guides/vehicles"
  static GuidesHelicopterPage = "/guides/helicopter"
  static GuidesReputationPage = "/guides/reputation"
  static GuidesBotsPage = "/guides/bots"
  static GuidesMakingMoneyPage = "/guides/makingMoney"
  static GuidesHuntingPage = "/guides/hunting"
  static GuidesLeatherTanningPage = "/guides/leatherTanning"
  static GuidesFarmingPage = "/guides/farming"
  static GuidesMetalsForgingPage = "/guides/metals"
  static GuidesDirectConnectionPage = "/guides/directConnection"
  static GuidesBulletCalibers = "/guides/bulletCalibers"

  static ItemsDonatePage = "/items-donate"

  // Player
  static PlayerAreaPage = "/player-area"
  static PlayerAreaRepairBagPage = "/player-area/repair-bag"
  static PlayerTeleportPage = "/player-area/teleport"

  // Quests
  static QuestsListingPage = "/quests-area/listing"
  static QuestEditingPage = "/quests-area/editing"

  // Admin
  static AdminAreaPage = "/admin-area-page"
  static AdminAreaRebootServerPage = "/admin-area-page/reboot-server"
  static AdminAreaSetRunningValues = "/admin-area-page/set-running-values"
  static AdminAreaInGamePlayerDetailsPage = "/admin-area-page/in-game-player-details"
  static AdminAreaMapViewPage = "/admin-area-page/map-view"
  static AdminAreaPlayersListingPage = "/admin-area-page/players-listing"
  static AdminAreaNotificationToPlayer = "/admin-area-page/player-notification"

  static LoginSteamPage = "/steam/login"
  static LoginSteamReturnPage = "/steam/login-return"
}